<template>
<div>
    <loading-overlay :fetching="isFetching"></loading-overlay>
    <!-- 사용자 등록 -->
    <div v-if="insertProgress == 'userInsert'" class="card">
        <div class="card-header">파트너 사용자 등록
            <div style="color: coral;">필드 *표시는 필수값 입니다.</div>
        </div>
        <div class="card-body">
            <div>
                <form id="insertForm" method="post" enctype="multipart/form-data" Content-Type="application/json" >
                    <div class="form-body">
                        <h5 class="form-title">기재내용(선택)</h5>
                        <div style="color: coral;">사업자 및 프리랜서 선택 부탁드립니다.</div>
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" style="width: 50%;">
                                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true" @click="userState('company')">
                                    사업자
                                </a>
                            </li>
                            <li class="nav-item" style="width: 50%;">
                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false" @click="userState('free')">
                                    프리랜서
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent" style="margin-top: 15px;">
                            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div class="row">
                                    <div class="form-group  col-lg-5">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="inputGroupFileAddon01">사업자등록증 첨부</span>
                                        </div>
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" ref='cpyimageFile' v-on:change='cpyHandleFileUpload()'>
                                            <label class="custom-file-label" for="inputGroupFile01">{{cpyimageFileName}}</label>
                                        </div>
                                    </div>
                                    <div v-if="insertState == 'company'" class="form-group  col-lg-5">
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:25% font-size: small;">상호*</span>
                                            <input type="text" class="form-control checkRequired" v-model="form.cpyNam" 
                                            name="valuedation" ref='cpyNam' v-on:mousedown="removeClass('cpyNam',['is-invalid'])"  placeholder="회사명" title="상호">
                                        </div>
                                    </div>
                                    <div class="form-group  col-lg-5">
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:25% font-size: small;">사업자번호</span>
                                            <input type="text" class="form-control "  v-model="form.cpyNumber"
                                            name="valuedation" placeholder="사업자번호" title="사업자번호">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group  col-lg-5">
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:25% font-size: small;">사업자주소</span>
                                            <input type="text" class="form-control" v-model="form.cpyAddress"
                                            name="valuedation"  placeholder="사업자주소" title="사업자주소">
                                        </div>
                                    </div>
                                    <div class="form-group  col-lg-5">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="inputGroupFileAddon01">사업자 계좌(통장사본 첨부)</span>
                                        </div>
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" ref='bankimageFile' v-on:change='bankHandleFileUpload()'>
                                            <label class="custom-file-label" for="inputGroupFile01">{{bankimageFileName}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                <div class="row">
                                    <div class="form-group  col-lg-5">
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:25% font-size: small;">임금계좌번호</span>
                                            <input type="text" class="form-control" v-model="form.bankNumber"
                                            name="valuedation"  placeholder="임금계좌번호" title="임금계좌번호">
                                        </div>
                                    </div>
                                    <div class="form-group  col-lg-5">
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:25% font-size: small;">은행명</span>
                                            <input type="text" class="form-control " v-model="form.bankName"
                                            name="valuedation" placeholder="은행명" title="은행명">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </form>
                    <div class="row" style="justify-content: flex-end;">
                        <div>
                            <button type="button" class="btn btn-info" style="width: 100px;" v-on:click="nextInsert()">다  음</button>
                        </div>
                        <div style="width: 20px;"></div>
                        <div>
                            <button type="button" class="btn btn-secondary" style="width: 100px;" v-on:click="close">취소</button>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <!-- 계약서 -->
    <div v-if="insertProgress == 'contract'" class="card">
        <div class="card-header">계약서</div>
        <div class="card-body">
            <!-- 계약서 -->
            <div v-html="contractConect"></div>
            <div class="row" style="justify-content: flex-end;margin-top: 10px;">
                <div>
                    <button type="button" class="btn btn-info" style="width: 130px;" v-on:click="nextContract()">동의 및 등록</button>
                </div>
                <div style="width: 20px;"></div>
                <div>
                    <button type="button" class="btn btn-secondary" style="width: 100px;" v-on:click="close">취소</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import loadingOverlay from "@autonomus/web/vueLib/loading_overlay/LoadingOverlay";
import axios from 'axios';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import pathDefine from '@IM_node_modules/js/pathDefine.js'
import {isValidate} from '@IM_node_modules/js/common/validateCheck.js'
import {setdateFormat} from '@IM_node_modules/js/common/dateFormat.js'
import Compressor from 'compressorjs';

  export default {
    name: 'memberInsert',
    components: 
    {
        loadingOverlay,
    },
    data() {
      return {
        insertProgress:'userInsert',
        isFetching: false,
        useAgreement:false,
        personalAgreement:false,
        form: {
            cpyNam:'',
            address:'',
            cpyNumber:'',
            cpyAddress:'',
            bankNumber:'',
            bankName:'',
            },
        userIdDuplicate:null,
        userIdDuplicateMessage:'',
        cpyimageFileName:'이미지 파일 선택',
        cpyimageFile:'',
        cpyimageFileData:'',
        bankimageFileName:'이미지 파일 선택',
        bankimageFile:'',
        bankimageFileData:'',
        insertState:'company',
        contractConect: '',
      }
    },
    computed:
    {
        userInfo:function()
        {
            return this.$store.state.getUserInfo
        }
    },
    methods:
    {
        nextInsert()
        {
            if(this.checkValidation())
            {
                this.setContract();
                this.insertProgress = 'contract'
            }
        },
        nextContract()
        {
            this.insertUser();
        },
        userState(value)
        {
            this.insertState = value;
        },
        cpyHandleFileUpload() 
        {
            //첨부파일 데이터가 있는지 없는지 판단
            if(this.$refs.cpyimageFile.files[0])
            {
                let vue = this;
                //파일 바인딩
                vue.cpyimageFile = this.$refs.cpyimageFile.files[0];
                vue.cpyimageFileName = this.$refs.cpyimageFile.files[0].name

                //사진 사이즈 압축하기
                new Compressor(vue.cpyimageFile, {
                    //압축률
                    quality: 0.5,
                    success(result) {
                        let reader = new FileReader();
                        reader.addEventListener("load", function() {
                            vue.cpyimageFileData = reader.result;
                        }.bind(this), false);
                        reader.readAsDataURL(result);
                    },
                    error(err) {
                    console.log(err.message);
                    },
                });
            }
            else
            {
                //파일 빈값으로 바인딩
                this.cpyimageFile = '';
                this.cpyimageFileData = '';
                //파일이름 default으로 바인딩
                this.cpyimageFileName = '이미지 파일 선택';
            }

        },
        bankHandleFileUpload() 
        {
            //첨부파일 데이터가 있는지 없는지 판단
            if(this.$refs.bankimageFile.files[0])
            {
                let vue = this;
                //파일 바인딩
                vue.bankimageFile = this.$refs.bankimageFile.files[0];
                vue.bankimageFileName = this.$refs.bankimageFile.files[0].name

                //사진 사이즈 압축하기
                new Compressor(vue.bankimageFile, {
                    //압축률
                    quality: 0.5,
                    success(result) {
                        let reader = new FileReader();
                        reader.addEventListener("load", function() {
                            vue.bankimageFileData = reader.result;
                        }.bind(this), false);
                        reader.readAsDataURL(result);
                    },
                    error(err) {
                    console.log(err.message);
                    },
                });
            }
            else
            {
                //파일 빈값으로 바인딩
                this.bankimageFile = '';
                this.bankimageFileData = '';
                //파일이름 default으로 바인딩
                this.bankimageFileName = '이미지 파일 선택';
            }

        },
        //작성일:2020-04-27
        //1.개요:대표계정을 신청하는 메소드
        insertUser()
        {
            const formData = new FormData();
            formData.append('usrId',this.userInfo.usrId);
            formData.append('cpyNam',this.form.cpyNam);
            formData.append('cpyNumber',this.form.cpyNumber);
            formData.append('cpyAddress',this.form.cpyAddress);
            formData.append('bankNumber',this.form.bankNumber);
            formData.append('bankName',this.form.bankName);
            formData.append('cpyimageFileData',this.cpyimageFileData);
            formData.append('bankimageFileData',this.bankimageFileData);
            formData.append('contractConect',this.contractConect);
            formData.append('client','false');

            if(this.checkValidation())
            {
                //loading
                this.isFetching = true;
                axios.post(pathDefine.apiUrl.member.userUpdate,formData)
                  .then((response)=>
                  {
                      if(response.data.respFlag)
                      {
                          alert('등록에 성공하였습니다, 다시 로그인 부탁드립니다.')
                          location.href = "/user/auth/logout.do"
                      }
                      else
                      {
                          alert('등록에 실패하였습니다')
                      }
                  })
                  .catch(function (error) {
                    // handle error
                    console.log(error);
                  })
                  .then(function () {
                    // always executed
                    this.isFetching = false;
                  });
            }
        },
        //작성일:2020-04-27
        //1.개요:아이디 및 비밀번호 입력값 체크하여 true/false리턴하는 메소드
        checkValidation()
        {
            if(isValidate(document.getElementsByName('valuedation')))return;

            return true;
        },

        //작성일:2020-05-11
        //1.개요:클래스를 찾아 원하는 클래스로 변경하는 메소드
        //2.멤버변수: beforeClass-찾을려는 클래스,afterClass-바꿀 클래스
        changeClassName(beforeClass,afterClass)
        {
            var classAraay = document.getElementsByClassName(beforeClass);
            var Araaylength = classAraay.length;
            for(var i = 0; i<Araaylength; i++)
            {
                classAraay[0].className = afterClass;
            }

        },
        //작성일:2020-06-11
        //1.개요:태그에 특정 class를 제거하는 메소드
        //2.input: name-해당 태그에 ref값, className-제거할 class
        removeClass(name,className)
        {
            var classNameArray = className
            for(var i=0; i<classNameArray.length; i++)
            {
                this.$refs[name].classList.remove(classNameArray[i])
            }
        },
        close()
        {
            location.href='/memberInfo.do'
        },
        setContract()
        {
            let nowDate = setdateFormat(new Date(), 'YYYY년MM월DD일')
            let company = (this.form.cpyNam == "")? '프리랜서': this.form.cpyNam
            this.contractConect =
            `<div style="text-align: center; font-size: larger;"><b>판촉 마케팅 용역 위탁 계약서</b></div>
                <span>본 계약서를 작성함에 <b>피플러스세일즈플랫폼(주)</b> (이하 “갑”이라 한다)와 <b>${this.userInfo.usrNam}</b>
                (이하 “을”이라 한다)은 상호 간에 다음과 같이 판촉 마케팅 용역 위탁 계약을 체결한다.</span>

                <div style="font-size: larger;margin-top: 10px;"><b>제 1조 【목   적】</b></div>
                <span>본 계약은 “갑”의 의약품 판매의 촉진을 위한 판촉 마케팅 용역을 “을”이 대행함에서의 권리, 의무 및 기타 제반 사항을 정하는 것에 그 목적이 있다.</span>

                <div style="font-size: larger;margin-top: 10px;"><b>제 2조 【대상품목】</b></div>
                <span>“갑”이 취급하는 상품 전부를 본 계약의 대상품목으로 하며, 본 계약의 효력이 유지하는 동안 “갑”이 신규로 취급하는 품목도 포함한다.</span>

                <div style="font-size: larger;margin-top: 10px;"><b>제 3조 【마케팅 용역 내용】</b></div>
                <span>“갑”이 “을”에게 위탁하는 마케팅 용역의 내용은 다음과 같다.</span>
                <div>1. 마케팅 용역 위탁 대상 의약품의 정보전달 및 효능, 부작용 전달</div>
                <div>2. “갑”의 의약품 판매 촉진을 위하여 “을” 은 “을” 의 판단에 따른 모든 마케팅 활동을 수행할 수 있다. 단, “을” 의 마케팅 활동은 다음 각 호에 해당하여서는 아니 된다.</div>
                <div style="font-size: smaller; margin-left: 5px;">1)독점규제 및 공정거래에 관한 법률 제 23조에 어긋나는 행위</div>
                <div style="font-size: smaller; margin-left: 5px;">2)공정경쟁규약 제 5조에 어긋나는 행위</div>
                <div style="font-size: smaller; margin-left: 5px;">3)“갑”의 명에를 실추시키는 행위 또는 “을” 의 위법한 행위로 인하여 “갑” 이 제3자로부터 제소를 당하는 행위</div>
                <div>3. “을” 은 “을” 이 수행하는 용역이 계약서의 규정된 용역 범위를 초과하는지에 대한 추가적인 판단이 필요한 경우 사전에 “갑” 과 협의하여야 한다.</div>
                <div>4. 제 3조 2항의 1),2),3)의 법률 및 운용 기준이 개정되었을 경우 개정된 법률 및 운용기준을 따른다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 4조 【수수료 청구 및 지급방법】</b></div>
                <div>1. “갑” 은 “을” 의 마케팅 활동에 드는 인건비 및 경비를 위하여 정해진 마케팅 용역 위탁수수료를 지급하고 “을”은 “갑”에게 약정된 마케팅 용역 위탁수수료를 청구한다. 단, 처방 자료 대비 문전약국 매입금액이 80% 이상일 경우에 한한다.</div>
                <div>2. 처방 자료 대비 문전약국 매입금액이 80% 이하인 경우 “갑”은 “을”에게 이를 통지하고 증빙 자료를 추가로 요청할 수 있으며 “을”은 이에 응하고 “갑”이 요청한 기간 안에 소명해야한다.</div>
                <div>3. 처방 증빙 자료는 익월 15일까지 제출을 원칙으로 하며, 처방 후 2달이 경과할 때까지 제출되지 않은 자료에 해당하는 수수료는 지급하지 않는다.</div>
                <div>4. “을”은 상기 2항의 청구된 마케팅 용역 위탁 수수료를 “갑”과 “을”이 상호 검토 확인 후 “을”은 청구월 말일까지 세금계산서를 발행하고, “갑”은 익월 25일에 수수료를 지급하며, 지급일이 공휴일일 경우는 다음 영업일에 지급한다. 정산일 변경을 원할 경우 사전 협의한다.</div>
                <div>5. “갑”이 “을”에게 지급하는 수수료 이외의 제 경비는 “을”의 부담으로 한다.</div>
                <div>6. 사전 거래가능유무 확인 후 용역 활동을 개시할 수 있으며 코프로모션 제품의 경우 해당 회사의 규정에 따른다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 5조 【수수료 변경】</b></div>
                <div>1. 계약 기간에 원가상승 및 약가 인하 등으로 제3조 수수료의 변경이 필요하다고 인정되는 사유가 있을 때는 “갑”은 “을”에게 1개월 전 통보하고 그 범위는 양 당사자 간 협의에 의거하여 처리하는 것을 원칙으로 한다.</div>
                <div>2. 처방신규 후 4개월째부터는 해당 처방처의 처방 증빙자료가 10만원 미만일 시 수수료지급 대상에서 제외한다.</div>
                <div>3. 제 4조 3항의 “갑”의 증빙 자료 추가 제출 요청에 “을”이 “갑”이 요청한 기간 안에 응하지 않거나 소명하지 않을 시 “갑”은 수수료 지급을 중지하거나 문전약국 매입금액에 준하는 금액으로 수수료를 정산한다.</div>
                <div>4. 마케팅 용역 위탁수수료 청구 이력이 있는 처방처를 “을”이 이관 받아 수수료를 청구하는 경우 “갑”의 “거래관리규정”에 따른다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 6조 【별도 계약】</b></div>
                <div>1. “갑”과 “을”은 본 계약의 세부 분야를 시행하기 위해, 별도의 합의 각서나 계약서를 체결한다.</div>
                <div>2. 본 계약서에 명시되지 않는 거래관련 세부 규정은 “갑”의 “거래관리규정”에 따른다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 7조 【기밀 유지】</b></div>
                <div>“갑”과 “을”은 본 계약서에 의하여 교환되는 중요한 비밀정보, 기술, 서비스 등을 제3자에게 상호 협의 없이 유출하거나 판매 또는 이관할 수 없다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 8조 【제품의 변경】</b></div>
                <div>“갑”의 사정에 의해 제품 판매중단 또는 신제품 출하는 1개월 전 “을”에게 통보한다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 9조 【효력 발생, 개정 및 종료】</b></div>
                <div>1. 본 계약서의 효력은 계약 체결일로부터 1년까지 유효하며, 계약종료 1개월 전에 계약종료 의사를 서면으로 상대방에게 통지하지 않는 한, 1년 단위로 자동 연장된다. </div>
                <div>2. 본 계약서의 개정은 “갑”과 “을” 간의 합의로 가능하다.</div>
                <div>3. 제7조에 명시한 기밀유지에 관한 상호 의무는 본 계약서의 효력 종료 후에도 계속 유효하다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 10조 【계약 해지】</b></div>
                <div>1. “갑”의 승인 없이 부당거래로 인해 “갑”에게 손해를 끼치는 행위를 한 경우</div>
                <div>2. 제3조 2항의 각호에 해당하는 경우</div>
                <div>3. “갑” 또는 “을”이 제3자로부터 가압류, 가처분, 강제집행 등을 당하거나 계약당사자의 파산선고 또는 회사 정리의 신청 등 경영상의 중대한 사유가 발생하여 본 계약을 수행 할 능력이 없다고 인정되는 경우 통보 없이 계약을 해지할 수 있다.</div>
                <div>4. “을”이 “갑”의 승인 없이 제3자에게 “갑”이 공급한 상품 자료 및 홍보물을 양도, 담보설정, 대여, 교부 등의 처분을 하거나 정당한 이유 없이 점유한 경우</div>
                <div>5. “을”이 갑에게 제출하는 처방 증빙 서류를 위조 및 변조하는 등 마케틴 수수료를 허위 청구하는 경우</div>
                <div>6. “을”이 6개월 이상 처방 증빙자료를 제출하지 않을 경우</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 11조 【손해 배상】</b></div>
                <div>1. “갑”과 “을”은 본 계약서상의 의무를 위반하거나, 정당한 사유 없이 일방적으로 위약함으로써 발생하는 상대방의 손해에 대해 위약자가 손해액 전체를 상대방에게 변상하여야한다. 이때 정당한 사유란 천재지변이나 기타 인위적으로 대처할 수 없는 불가항력적인 사태를 뜻한다.</div>
                <div>2. 계약 쌍방은 이 계약을 위반하거나 의무사항을 지체한 경우에는 계약해지와 별도로 상대의 손해에 대하여 배상 및 보상하여야 한다.</div>
                <div>3. 제10조 5항에 해당하는 경우 “을”은 그 즉시 마케팅용역 위탁수수료를 청구할 권리를 상실하며, “을”은 “갑”에게 부당청구금액의 5배수 금액을 배상한다.</div>
                <div>4. “을”이 경제적 이익 등의 제공에 관한 지출 보고 의무를 이행하지 않거나 허위의 자료를 제출하여 “갑”에게 손해배상의무 또는 피해가 발생한 경우, “을”은 “갑”에게 관련손해 일체를 배상해야한다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 13조 【계약서 작성 및 보관】</b></div>
                <div>본 계약서의 해석이나 적용에 관한 분쟁은 일반 상 관례에 따라 상호 간의 협의에 의거하여 해결함을 원칙으로 하나, 상호협의로 해결이 되지 않을 경우 “갑”의 소재지 관할 법원을 지정 법원으로 하여 해결한다.</div>

                <div style="font-size: larger;margin-top: 10px;"><b>제 9조 【효력 발생, 개정 및 종료】</b></div>
                <div>1. 본 계약서는 피플러스세일즈플랫폼(주)의 서버에 저장되며 계약 동의에 체크함으로써 양사의 날인을 생략한다.</div>
                <div>2. “을”이 본 계약서를 요청할시 “갑”은 계약서를 서면으로 출력하여 “을”에게 제공한다.</div>


                <div style="text-align: center; font-size: larger;margin-top: 20px;"><b>준수 서약서</b></div>
                <span><b>${this.userInfo.usrNam}</b>(회원사명)은 <b>피플러스세일즈플랫폼(주)</b>와 입찰, 위탁업무, 계약이행 등 모든 업무를 수행함에 있어 다음 사항을 준수할 것을 서약합니다.</span>

                <div style="margin-top: 10px;">1. 본인은 피플러스세일즈플랫폼(주) 의약품의 판매촉진을 위한 마케팅, 영업활동 등을 수행함에 있어 『독점규제 및 공정거래에 관한 법률』, 『의약품 거래에 관한 공정경쟁규약』, 『약사법』, 『의료법』, 『부정 청탁 및 금품 등 수수의 금지에 관한 법률』, 『형법』 등 뇌물, 부패방지에 관계된 모든 국내외 법률 및 부패방지방침, 윤리강령 및 관련 규정을 성실히 준수하겠습니다.</div>
                <div style="margin-top: 10px;">2. 본인은 피플러스세일즈플랫폼(주) 의약품의 판매촉진을 위한 마케팅, 영업활동 등을 수행함에 있어 『독점규제 및 공정거래 에 관한 법률』 및 『의약품 거래에 관한 공정경쟁규약』에서 정하는 부당한 고객유인행위를 지양하며, 의약품의 채택, 처방 유도 등 판매촉진을 목적으로 보건의료전문가 및 이해관계자에게 금전, 물품, 편익, 노무, 향응 등 어떠한 경제적 이익 등을 제공하지 않을 것임을 확인합니다.</div>
                <div style="margin-top: 10px;">3. 본인은 『약사법』 제 47조의2에 따라 경제적이익등 제공 내역에 관한 지출보고서를 작성 및 보관하며, 이와 관련하여 항상 완전하고 정확한 기록을 유지, 보관할 것임을 확인합니다.</div>
                <div style="margin-top: 10px;">4. 본인은 본인의 임직원, 협력업체, 소속영업사원 등에게 『약사법』 및 『의약품 거레에 관한 공정경쟁규약』 등 관련 법령에 관한 교육을 수시로 받도록 하여야 하며, 이와 관련하여 피플러스세일즈플랫폼(주)가 요청 시 실사에 협조할 것임을 확인합니다.</div>
                <div style="margin-top: 10px;">5. 본인은 피플러스세일즈플랫폼(주) 의약품의 판매촉진을 위한 마케팅, 영업활동 등을 수행함에 있어 관련 법령을 위반하거나 피플러스세일즈플랫폼(주)로 하여금 위반하도록 한적이 없음을 진술하고 이를 확인합니다.</div>
                <div style="margin-top: 10px;">6. 본인은 상기 진술이 모두 정확한 사실임을 확인하며, 본 서약의 내용을 위반할 경우 금전, 물품, 인력, 신뢰 손상 등 발생하는 모든 결과에 대해 의법 처리되며 피플러스세일즈플랫폼(주)와 관련된 모든 계약이 해지될 수 있음을 확인합니다.</div>
                
                <div style="text-align: end; margin-top: 20px;"><b>${nowDate}</b></div>
                <div style="text-align: end; font-size: larger;margin-top: 20px;"><b>▶ 회사명   :${company}</b></div>
                <div style="text-align: end; font-size: larger;margin-top: 20px;"><b>▶ 대표자명 :${this.userInfo.usrNam}</b></div>`
        },

    },
    created: function()
    {
    },


  }
</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>